import { 
    GET_HISTORY_DEVICE_EXCEL, 
    GET_HISTORY_DEVICE_EXCEL_SUCCESS, 
    GET_HISTORY_DEVICE_EXCEL_ERROR 
} from "../../../constants/historyDevice";

export const getHistoryToExcel = (state: any = false, actions: any) => {
  switch (actions.type) {
      case GET_HISTORY_DEVICE_EXCEL:
      return {
        ...state,
        loading: true,
      };
    case GET_HISTORY_DEVICE_EXCEL_ERROR:
      return {
        data: null,
        loading: false,
        error: null,
      };
    case GET_HISTORY_DEVICE_EXCEL_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        data: actions.payload,
      };
    default:
      return state;
  }
};
